import AllServices from '../../../config/AllServices';

let customServices = [{ checked: false, value: 'EC2' }];
AllServices.All.filter(s => {
  let checkColon = s.key.includes('EC2:');
  if (!checkColon) {
    customServices.push({
      checked: false,
      value: s.key,
    });
  }
});

const FiltersConstants = [
  {
    orderOfDisplay: 3,
    type: 'riskStatus',
    label: 'Risk Status',
    values: [{ checked: false, value: 'fail' }, { checked: false, value: 'pass' }],
  },
  {
    orderOfDisplay: 4,
    type: 'risk_level',
    label: 'Severity',
    values: [
      { checked: false, value: 'low' },
      { checked: false, value: 'medium' },
      { checked: false, value: 'high' },
    ],
  },
  {
    orderOfDisplay: 1,
    type: 'service',
    label: 'Services',
    values: customServices,
  },
  {
    orderOfDisplay: 5,
    type: 'category',
    label: 'Categories',
    values: AllServices.CATEGORIES.map(c => {
      return {
        checked: false,
        value: c.text,
      };
    }),
  },
  {
    orderOfDisplay: 2,
    type: 'region',
    label: 'Regions',
    values: [
      { checked: false, value: 'us-east-1' },
      { checked: false, value: 'us-east-2' },
      { checked: false, value: 'us-west-1' },
      { checked: false, value: 'us-west-2' },
      { checked: false, value: 'eu-west-3' },
      { checked: false, value: 'eu-west-1' },
      { checked: false, value: 'eu-west-2' },
      { checked: false, value: 'eu-central-1' },
      { checked: false, value: 'us-central1' },
      { checked: false, value: 'ap-south-1' },
      { checked: false, value: 'ap-southeast-1' },
      { checked: false, value: 'ap-southeast-2' },
      { checked: false, value: 'ap-northeast-1' },
      { checked: false, value: 'ap-northeast-2' },
      { checked: false, value: 'sa-east-1' },
      { checked: false, value: 'ca-central-1' },
      { checked: false, value: 'eastasia' },
      { checked: false, value: 'southeastasia' },
      { checked: false, value: 'centralus' },
      { checked: false, value: 'eastus' },
      { checked: false, value: 'westus' },
      { checked: false, value: 'northcentralus' },
      { checked: false, value: 'southcentralus' },
      { checked: false, value: 'northeurope' },
      { checked: false, value: 'westeurope' },
      { checked: false, value: 'japanwest' },
      { checked: false, value: 'japaneast' },
      { checked: false, value: 'brazilsouth' },
      { checked: false, value: 'australiaeast' },
      { checked: false, value: 'australiasoutheast' },
      { checked: false, value: 'southindia' },
      { checked: false, value: 'centralindia' },
      { checked: false, value: 'westindia' },
      { checked: false, value: 'canadacentral' },
      { checked: false, value: 'canadaeast' },
      { checked: false, value: 'uksouth' },
      { checked: false, value: 'ukwest' },
      { checked: false, value: 'westcentralus' },
      { checked: false, value: 'koreacentral' },
      { checked: false, value: 'koreasouth' },
      { checked: false, value: 'Global' },
    ],
  },
  {
    orderOfDisplay: 6,
    type: 'g_by',
    label: 'Group By',
    values: [
      { checked: false, value: 'Logging' },
      { checked: false, value: 'Monitoring' },
      { checked: false, value: 'Networking' },
      { checked: false, value: 'Performance' },
      { checked: false, value: 'Disaster Recovery' },
      { checked: false, value: 'Encryption at Rest' },
      { checked: false, value: 'Encryption in Motion' },
    ],
  },
  {
    orderOfDisplay: 7,
    type: 'function',
    label: 'Functions',
    values: AllServices.FUNCTIONS.map(c => {
      return {
        checked: false,
        value: c.text,
      };
    }),
  },
];

export default FiltersConstants;
